import { forwardRef, LegacyRef, ReactNode } from 'react'
import clsx from 'clsx'

interface IContainer {
  className?: string;
  children?: ReactNode;
  ref?: LegacyRef<HTMLDivElement>;
  Outer?: any;
  Inner?: any;
  style?: any;
}

const OuterContainer = forwardRef(function OuterContainer(
  { className, children, ref }: IContainer
) {

  return (
    <div ref={ref} className={clsx('sm:px-8', className)}>
      <div className="mx-auto max-w-7xl lg:px-8">{children}</div>
    </div>
  )
})

const InnerContainer = forwardRef(function InnerContainer(
  { className, children, ref }: IContainer
) {
  return (
    <div
      ref={ref}
      className={clsx('relative px-4 sm:px-8 lg:px-12', className)}
    >
      <div className="mx-auto max-w-xl lg:max-w-4xl">{children}</div>
    </div>
  )
})

export const Container = forwardRef(function Container(
  { children, className, ref }: IContainer
) {

  const outer = OuterContainer;
  const inner = InnerContainer;
  
  return (
    <OuterContainer className={className}>
      <InnerContainer>{children}</InnerContainer>
    </OuterContainer>
  )
})

//Container.Outer = OuterContainer
// Container.Inner = InnerContainer
